module.exports = __webpack_public_path__ + "img/game-back.47b22438.svg";